import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Autocomplete,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Alert,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { Formik, Field } from "formik";
import * as yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageTitles from "../components/Layout/PageTitles";
import LoadingButton from "@mui/lab/LoadingButton";
import { useParams } from "react-router-dom";

const RegisterNewUser = ({ setOpen, refresh, setRefresh }) => {
  const [orgsList, setOrgsList] = useState([]);
  const [allOrgs, setAllOrgs] = useState([]);
  const [accountStateArray, setAccountStateArray] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [alert, setAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [password, setPassword] = useState("");
  const [reset, setReset] = useState(false);
  const [updateOrgs, setUpdateOrgs] = useState(0);
  const [allUsernames, setAllUsernames] = useState([]);
  const [allEmails, setAllEmails] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [resetKey2, setResetKey2] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [unBtnLoading, setUnBtnLoading] = useState(false);

  const { applicant_id } = useParams();
  const [applicant, setApplicant] = useState({});
  const [isLoading, setIsLoading] = useState(!!applicant_id);

  const navigate = useNavigate();

  useEffect(() => {
    if (applicant_id) {
      axios
        .get("/get_applicant/" + applicant_id)
        .then((res) => {
          setApplicant(res.data.applicant);
        })
        .then(() => {
          setIsLoading(false);
        })
        .catch((err) => {
          setErrorAlert(true);
          setAlertContent(err.response.data);
          setIsLoading(false);
        });
    }
  }, []);

  const scrollElement = document.getElementById("RegUserContainer");

  useEffect(() => {
    axios
      .get("/get_account_states")
      .then((res) => {
        setAccountStateArray(res.data.accountStates);
      })
      .catch((error) => {});

    axios.get("/users").then((res) => {
      const users = res.data.users.map((user) => user.username);
      const emails = res.data.users.map((user) => user.email);
      setAllEmails(emails);
      setAllUsernames(users);
    });

    axios.get("/orgs").then((res) => {
      const orgs = res.data.orgs.map((org) => org.client);
      setAllOrgs(orgs);
    });
  }, []);

  useEffect(() => {
    axios.get("/orgs").then((res) => {
      const keys = res.data.orgs.filter((org) => dayjs(org.expiry) > dayjs());
      keys.unshift({ id: -1, client: "--- NEW KEY ---" });

      setOrgsList(keys);
    });
  }, [updateOrgs]);

  const makePassword = (setFieldValue) => {
    setBtnLoading(true);
    axios
      .get("/get_password")
      .then((res) => {
        setFieldValue("password", res.data.password);
        setBtnLoading(false);
      })
      .catch((error) => {
      
        setBtnLoading(false);
      });
  };

  const makeUsername = (values, setFieldValue) => {
    setUnBtnLoading(true);
    axios
      .post("/make_username", {
        firstname: values.firstName,
        lastname: values.lastName,
      })
      .then((res) => {
        setFieldValue("username", res.data['username']);
        setUnBtnLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setUnBtnLoading(false);
      });

    // setFieldValue("username", values.firstName+values.lastName)
  };

  const initialValues = {
    firstName: applicant.firstName || "",
    lastName: applicant.lastName || "",
    company: applicant.org || "",
    email: applicant.email || "",
    username: "",
    password: "",
    inputIPAddress: "",
    inputKey: -1,
    inputNoIP: true,
    inputStartDate: "",
    inputConfName: "",
    inputEndDate: "",
    inputGeneric: false,
    inputAcType: "standard",
    inputState: 1,
    applicantID: applicant.id || null,
    inputWelcome: false,
  };

  const userSchema = yup.object().shape({
    firstName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    lastName: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Required")
      .transform((value) => value.toLowerCase())
      .notOneOf(
        allEmails.map((email) => email.toLowerCase()),
        "Email already exists"
      ),
    inputKey: yup.number(),
    company: yup
      .string()
      .min(2, "Too Short!")
      .max(50, "Too Long!")
      .transform((value) => value.toLowerCase())
      .notOneOf(
        allOrgs.map((org) => org.toLowerCase()),
        "Organisation already exists"
      )
      .test(
        "Exactly 1 Org specified",
        "If creating a new organisation, select --- NEW KEY --- from Subscription key field. If using an existing organisation, leave this blank",
        function (company) {
          const { inputKey } = this.parent;
          // Fail when both have values or neither have values
          return !(
            (inputKey !== -1 && company) ||
            (inputKey === -1 && !company)
          );
        }
      ),
    username: yup
      .string()
      .min(5, "Too Short!")
      .max(10, "Too Long!")
      .required("Required")
      .notOneOf(allUsernames, "Username already exists")
      .matches(
        /^[a-z0-9]+$/,
        "Username must contain only lowercase letters and no spaces"
      ),
    password: yup
      .string()
      .min(8, "Too Short!")
      .max(35, "Too Long!")
      .test(
        "passwordCheckbox",
        'Enter a password or select "Create password" below',
        function (password) {
          const { inputWelcome } = this.parent;
          // Fail when both have values or neither have values
          return !((inputWelcome && password) || (!inputWelcome && !password));
        }
      ),
    inputIPAddress: yup
      .string()
      .matches(
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:, ?(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))*$|^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}($|,([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4})+$/,
        "Invalid IP address. If you wish to add more than one IP address, then separate the IP addresses with a comma and no spaces"
      )
      .test(
        "inputIPAddressCheckbox",
        "Enter an IP address or select the checkbox below",
        function (inputIPAddress) {
          const { inputNoIP } = this.parent;
          // Fail when both have values or neither have values
          return !(
            (inputNoIP && inputIPAddress) ||
            (!inputNoIP && !inputIPAddress)
          );
        }
      ),
    inputStartDate: yup
      .string()
      .matches(
        /^([1-9]\d{3}|2100)-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        "Invalid date"
      )
      .required("Required"),
    inputEndDate: yup
      .string()
      .matches(
        /^([1-9]\d{3}|2100)-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        "Invalid date"
      )
      .required("Required"),
  });

  const compareStartAndEndDate = (startDate, endDate, setFieldValue) => {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);

    if (startDate === endDate) return;

    if (startDate && endDate) {
      if (d1 > d2) {
        setFieldValue("inputEndDate", "");
        setResetKey2(resetKey2 + 1);
      }
    }
  };

  const myHandleReset = (values) => {
    values["inputStartDate"] = initialValues.inputStartDate;
    values["inputEndDate"] = initialValues.inputEndDate;
    setResetKey(resetKey + 1);
  };

  const handleFormSubmit = (values, { resetForm }) => {
    if (setOpen) {
      setOpen(false);
      setRefresh(refresh + 1);
    }
    axios
      .post("/register_user",  {values: values})
      .then((res) => {
        if (res.data.message === "User added") {
          setAlertContent("User has been added successfully");
          setAlert(true);
          setReset(true);
          setUpdateOrgs(updateOrgs + 1);
          scrollElement.scrollIntoView({ block: "start", behavior: "smooth" });
          resetForm({ values: initialValues });
          setResetKey(resetKey + 1);
          setResetKey2(resetKey2 + 1);
          if (applicant_id) navigate(`/applicants`);
        }
      })
      .catch((error) => {
        setErrorAlert(true);
        setAlertContent("There was an error when adding user!");
      });
  };

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  else
    return (
      <Box m="20px" id="RegUserContainer">
        <div
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <PageTitles title={"Register New User"} />
        </div>
        <br />
        {alert ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="success"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        {errorAlert ? (
          <Alert
            onClose={() => {
              setErrorAlert(false);
            }}
            severity="error"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        <br />
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={userSchema}
        >
          {({
            values,
            errors,
            touched,
            resetForm,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            dirty,
          }) => (
            <form onSubmit={handleSubmit} onReset={resetForm}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <Typography sx={{ gridColumn: "span 4" }}>
                  User details
                </Typography>
                <TextField
                  autoFocus={!applicant["firstName"]}
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.firstName}
                  name="firstName"
                  error={!!touched.firstName && !!errors.firstName}
                  helperText={touched.firstName && errors.firstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.lastName}
                  name="lastName"
                  error={!!touched.lastName && !!errors.lastName}
                  helperText={touched.lastName && errors.lastName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Organisation"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.company}
                  name="company"
                  error={!!touched.company && !!errors.company}
                  helperText={touched.company && errors.company}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  autoFocus={!!applicant["firstName"]}
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Username"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.username}
                  name="username"
                  error={!!touched.username && !!errors.username}
                  helperText={touched.username && errors.username}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  disabled={values.inputWelcome}
                  variant="filled"
                  type="text"
                  label="Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={!values.inputWelcome ? values.password : ""}
                  name="password"
                  error={!!touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                  sx={{ gridColumn: "span 2" }}
                />
                <LoadingButton
                  disabled={!values.firstName || !values.lastName}
                  variant="contained"
                  size="medium"
                  loading={unBtnLoading}
                  sx={{
                    m: "10px",
                    backgroundColor: "#2196f3",
                    "&:hover": { backgroundColor: "#0d47a1" },
                  }}
                  onClick={() => {
                    makeUsername(values, setFieldValue);
                  }}
                >
                  create username
                </LoadingButton>
                <LoadingButton
                  disabled={values.inputWelcome}
                  variant="contained"
                  size="medium"
                  loading={btnLoading}
                  sx={{
                    m: "10px",
                    backgroundColor: "#2196f3",
                    "&:hover": { backgroundColor: "#0d47a1" },
                  }}
                  onClick={() => {
                    makePassword(setFieldValue);
                  }}
                >
                  create a new password
                </LoadingButton>
                <Typography sx={{ gridColumn: "span 4" }}>
                  Account details
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    key={resetKey}
                    fullWidth
                    disablePast
                    sx={{ gridColumn: "span 2" }}
                    label="Start date"
                    value={values.inputStartDate}
                    inputFormat="DD/MM/YYYY"
                    name="inputStartDate"
                    onChange={(newValue) => {
                      const newValue2 =
                        "" +
                        dayjs(newValue).year() +
                        "-" +
                        ("0" + (dayjs(newValue).month() + 1)).substring(
                          ("0" + (dayjs(newValue).month() + 1)).length - 2
                        ) +
                        "-" +
                        ("0" + dayjs(newValue).date()).substring(
                          ("0" + dayjs(newValue).date()).length - 2
                        );
                      setStartDate(newValue2);
                      compareStartAndEndDate(newValue2, endDate, setFieldValue);
                      setFieldValue("inputStartDate", newValue2);
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          width: "100%",
                        }}
                        {...params}
                        name="inputStartDate"
                        error={
                          !!touched.inputStartDate && !!errors.inputStartDate
                        }
                        helperText={
                          touched.inputStartDate && errors.inputStartDate
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    key={resetKey2}
                    fullWidth
                    disablePast
                    disabled={!values.inputStartDate}
                    minDate={startDate}
                    sx={{ gridColumn: "span 2" }}
                    label="End date"
                    value={values.inputEndDate}
                    inputFormat="DD/MM/YYYY"
                    name="inputEndDate"
                    onChange={(newValue) => {
                      const newValue2 =
                        "" +
                        dayjs(newValue).year() +
                        "-" +
                        ("0" + (dayjs(newValue).month() + 1)).substring(
                          ("0" + (dayjs(newValue).month() + 1)).length - 2
                        ) +
                        "-" +
                        ("0" + dayjs(newValue).date()).substring(
                          ("0" + dayjs(newValue).date()).length - 2
                        );
                      setEndDate(newValue2);
                      setFieldValue("inputEndDate", newValue2);
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          width: "100%",
                        }}
                        {...params}
                        name="inputEndDate"
                        error={!!touched.inputEndDate && !!errors.inputEndDate}
                        helperText={touched.inputEndDate && errors.inputEndDate}
                      />
                    )}
                  />
                </LocalizationProvider>
                <Autocomplete
                  key={resetKey}
                  name="inputKey"
                  options={orgsList}
                  fullWidth
                  sx={{ gridColumn: "span 2" }}
                  getOptionLabel={(option) => option.client}
                  isOptionEqualToValue={(option, value) =>
                    option.id == value.id
                  }
                  onChange={(event, value) => {
                    setFieldValue("inputKey", value.id);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Subscription key" />
                  )}
                />
                <TextField
                  select
                  value={values.inputAcType}
                  name="inputAcType"
                  label="Account Type"
                  onChange={handleChange}
                >
                  <MenuItem key={"standard"} value={"standard"}>
                    Standard
                  </MenuItem>
                  <MenuItem key={"free"} value={"free"}>
                    Free
                  </MenuItem>
                  <MenuItem key={"view"} value={"view"}>
                    Viewer
                  </MenuItem>
                  <MenuItem key={"plus"} value={"plus"}>
                    Plus
                  </MenuItem>
                  {values.inputAcType == "admin" && (
                    <MenuItem key={"admin"} value={"admin"}>
                      Admin
                    </MenuItem>
                  )}
                </TextField>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="inputGeneric"
                      checked={values.inputGeneric}
                      onChange={() => {
                        setFieldValue("inputGeneric", !values.inputGeneric);
                      }}
                      sx={{ mr: "20px" }}
                    />
                  }
                  label="Generic account?"
                  labelPlacement="start"
                  sx={{ ml: "0", mr: "20px" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Confluence name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.inputConfName}
                  name="inputConfName"
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  disabled={values.inputNoIP}
                  variant="filled"
                  type="text"
                  label="IP address(es)"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={!values.inputNoIP ? values.inputIPAddress : ""}
                  name="inputIPAddress"
                  error={!!touched.inputIPAddress && !!errors.inputIPAddress}
                  helperText={touched.inputIPAddress && errors.inputIPAddress}
                  sx={{ gridColumn: "span 2" }}
                />
                <Field name="inputState" sx={{ gridColumn: "span 2" }}>
                  {({ field }) => (
                    <FormControl>
                      {accountStateArray.length > 0 ? (
                        <TextField
                          select
                          label="State"
                          sx={{ gridColumn: "span 2" }}
                          id="inputState"
                          {...field}
                          onChange={handleChange}
                        >
                          {accountStateArray.map(({ stateid, statename }) => (
                            <MenuItem key={stateid} value={stateid}>
                              {statename}
                            </MenuItem>
                          ))}
                        </TextField>
                      ) : (
                        <TextField
                          disabled
                          id="inputState"
                          fullWidth
                          required
                          label="State"
                          value={"Inactive"}
                        ></TextField>
                      )}
                    </FormControl>
                  )}
                </Field>

                <FormControlLabel
                  control={
                    <Checkbox
                      name="inputNoIP"
                      checked={values.inputNoIP}
                      onChange={() => {
                        setFieldValue("inputIPAddress", "").then(() => {
                          setFieldValue("inputNoIP", !values.inputNoIP);
                        });
                      }}
                      sx={{ mr: "20px" }}
                    />
                  }
                  label="Leave blank to set at first use.
                Account not tied to single IP address"
                  labelPlacement="start"
                  sx={{ gridColumn: "span 2" }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="inputWelcome"
                      checked={values.inputWelcome}
                      onChange={() => {
                        setFieldValue("password", "").then(() => {
                          setFieldValue("inputWelcome", !values.inputWelcome);
                        });
                      }}
                      sx={{ mr: "20px" }}
                    />
                  }
                  label="Create password and send welcome e-mail?"
                  labelPlacement="start"
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Create New User
                </Button>
                <Button
                  type="reset"
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    myHandleReset(values);
                  }}
                >
                  Reset
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
};

export default RegisterNewUser;
